export default __webpack_public_path__ + "static/media/44.5da0d6f6.jpeg";